export default __webpack_public_path__ + "static/media/rnr-sports-table-1-cn.d7a2d177.webp";